import React from 'react';
import { Trash2, AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName, itemType }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-white border border-gray-200 text-gray-900 shadow-2xl">
        <DialogHeader className="space-y-4">
          <div className="mx-auto bg-red-100 p-4 rounded-full w-fit ring-4 ring-red-50 animate-pulse">
            <AlertTriangle className="h-8 w-8 text-red-600" />
          </div>
          <DialogTitle className="text-center text-2xl font-bold text-gray-900">Confirmar Exclusão</DialogTitle>
          <DialogDescription className="text-center text-gray-600 text-base">
            Tem certeza que deseja deletar este item?
            <br />
            <span className="font-bold text-gray-900 mt-2 block text-lg bg-gray-100 py-1 px-3 rounded-lg border border-gray-200">"{itemName}"</span>
          </DialogDescription>
        </DialogHeader>
        
        <div className="bg-red-50 border border-red-100 rounded-lg p-3 text-center my-4">
          <p className="text-red-600 text-sm font-semibold flex items-center justify-center gap-2">
            <AlertTriangle className="w-4 h-4" />
            Esta ação é irreversível e não pode ser desfeita.
          </p>
        </div>

        <DialogFooter className="sm:justify-center gap-3 w-full">
          <Button variant="outline" onClick={onClose} className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50 font-medium">
            Cancelar
          </Button>
          <Button 
            variant="destructive" 
            onClick={onConfirm}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white gap-2 font-bold shadow-lg shadow-red-500/20"
          >
            <Trash2 className="w-4 h-4" />
            Deletar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationModal;